import { z } from 'zod'
import { Model } from './architecture'

export const PageNumberValidation = z.object({
  value: z.number({ required_error: '[PageNumber] value is required' }).int().min(0),
})

export class PageNumber extends Model {
  static create({ value }: z.infer<typeof PageNumberValidation>) {
    PageNumberValidation.parse({ value })
    return new PageNumber(value)
  }

  static empty() {
    return new PageNumber(0)
  }

  static fromNumber(num: number) {
    return PageNumber.create({ value: num })
  }

  constructor(private readonly _value: number) {
    super()
  }

  get value() { return this._value } // prettier-ignore

  toJSON() {
    return { value: this.value }
  }
}
